<section class="popular__destinations">
    <div class="popular__destinations__content pb-4">
        <div class="popular__destinations__content__container container">
            <div
                class="popular__destinations__content__container__title row d-flex align-items-center"
            >
                <h2
                    class="popular__destinations__content__container__title__text col-slmd-8 pt-4 py-slmd-4 m-0 justify-content-center text-center text-slmd-start"
                >
                    {{ 'fe_landing_popular_destinations_title' | translate }}
                </h2>
                <div
                    class="col-slmd-4 py-slmd-4 d-flex justify-content-center justify-content-slmd-end"
                >
                    <fe-button
                        [style]="'link-tertiary'"
                        [href]="'locations-and-offices' | formatUrl"
                        ><span
                            class="popular__destinations__content__container__title__href"
                            >{{
                                'fe_landing_popular_destinations_href'
                                    | translate
                            }}</span
                        ></fe-button
                    >
                </div>
            </div>
            <div class="popular__destinations__content__container__extra row">
                <ng-container
                    *ngIf="
                        !popularDestinations;
                        else popularDestinationsContent
                    "
                >
                    <div
                        *ngFor="let placeholder of placeholders"
                        class="popular__destinations__content__container__extra__img col-12 col-sm-6 col-lg-4 d-flex flex-column placeholder-wave"
                    >
                        <a>
                            <img
                                [src]="'assets/images/nopic.webp' | cdn"
                                alt="Loading Placeholder"
                                class="mb-3 force-ratio placeholder"
                            />
                        </a>
                        <a class="placeholder">{{
                            'fe_landing_blog_alamo_placeholder' | translate
                        }}</a>
                    </div>
                </ng-container>
                <ng-template #popularDestinationsContent>
                    <div
                        *ngFor="
                            let popularDestinationsItem of popularDestinations
                                ?.data?.popularDestinations
                        "
                        class="popular__destinations__content__container__extra__img col-12 col-sm-6 col-lg-4 d-flex flex-column position-relative"
                        [ngClass]="{
                            'placeholder placeholder-wave':
                                !popularDestinationsItem.city
                        }"
                    >
                        <a
                            [routerLink]="
                                ('destination-airport/' | formatUrl) +
                                popularDestinationsItem.id +
                                '/ciudad'
                            "
                            class="position-relative mb-3 link"
                        >
                            <img
                                (error)="onImageError($event)"
                                [src]="
                                    popularDestinationsItem.path ||
                                    ('images/nopic.webp' | cdn)
                                "
                                [alt]="
                                    popularDestinationsItem.city ||
                                    'Placeholder Image'
                                "
                                class="force-ratio"
                            />
                            <div class="gradient-overlay"></div>
                        </a>
                        <a
                            [routerLink]="
                                ('destination-airport/' | formatUrl) +
                                popularDestinationsItem.id +
                                '/ciudad'
                            "
                            class="position-absolute text-overlay"
                        >
                            <p>
                                {{
                                    'fe_landing_popular_destinations_img_one'
                                        | translate
                                        | replace
                                            : {
                                                  city: popularDestinationsItem.city
                                              }
                                }}
                            </p>
                            <p>
                                {{
                                    'fe_landing_popular_destinations_img_two'
                                        | translate
                                        | replace
                                            : {
                                                  minPrice:
                                                      popularDestinationsItem.minPrice
                                              }
                                }}
                            </p>
                        </a>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</section>
